import React, { ReactNode } from "react";
import { GridIcon as Grid, ListIcon as List, TreeIcon as Tree } from "../Icons";
import { ToggleProps, ToggleType, ToggleLayout } from "./Toggle.types";
import { Layout } from "./Toggle.styles";

const getIcon = (layout: string | undefined, customIcon?: ReactNode) => {
  switch (layout) {
    case ToggleLayout.grid:
      return <Grid />;
    case ToggleLayout.tree:
      return <Tree />;
    case ToggleLayout.list:
      return <List />;
    case ToggleLayout.custom:
      return customIcon;
    default:
      return null;
  }
};

/**
 * Toggle component for switching between different states or layouts
 */
export const Toggle = ({
  toggleType = ToggleType.text,
  disabled,
  text,
  layout,
  customIcon,
  onPressedChange,
  pressed,
  className,
  ...props
}: ToggleProps) => {
  return (
    <Layout
      {...props}
      className={className}
      $toggleType={toggleType}
      disabled={disabled}
      pressed={pressed}
      onPressedChange={onPressedChange}
      aria-label="toggle-layout"
    >
      {toggleType === ToggleType.text ? text : getIcon(layout, customIcon)}
    </Layout>
  );
};
